import type { DocumentNode } from "graphql";
import type { BackendTeam } from "./fieldOwners.generated";
import { FIELD_OWNERS } from "./fieldOwners.generated";

// The ownership key when a GraphQL error carries no usable `path`
// (request-level failures, raw network errors): the operation's first
// top-level field.
const firstOperationField = (query: DocumentNode): string | undefined => {
  for (const definition of query.definitions) {
    if (definition.kind === "OperationDefinition") {
      for (const selection of definition.selectionSet.selections) {
        if (selection.kind === "Field") return selection.name.value;
      }
    }
  }
  return undefined;
};

/**
 * The backend team owning a failed operation, from the schema's `@owner`
 * directive. The error path is tried first, but it holds response keys —
 * an aliased field misses the map — so the operation's first top-level
 * field (always the schema name) is the fallback.
 */
export const owningTeam = (
  path: readonly (string | number)[] | undefined,
  query: DocumentNode,
): BackendTeam | undefined =>
  FIELD_OWNERS[String(path?.[0] ?? "")] ??
  FIELD_OWNERS[firstOperationField(query) ?? ""];
